import Box from '@/Atoms/Box';
import CCLoader from '@/Atoms/CCLoader';
import CCPackageTable from '@/Atoms/CCPackageTable';
import CCText from '@/Atoms/CCText';
import Spacer from '@/Atoms/Spacer';
import useGetSubscriptionDetailsApi from '@/Hooks/SubscriptionDetails/useSubscriptionDetails';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Pagination from '@/Screens/Games/Pagination';

import CCColors from '@/Utils/CCColors';
import {FontSizes, vs, WINDOW_WIDTH} from '@/Utils/Dimensions';
import React, {useEffect, useState} from 'react';
import {
  Image,
  Linking,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import styles from './styles';
import CCButton from '@/Atoms/CCButton';
import EmptyView from '../EmptyView';
// import useGetRenewalForUser from '@/Hooks/RenewalApi/useGetRenewalForUser';
// import RenewalBanner from '@/Screens/Renewal/components/RenewalBanner';
import {getSubscriptionBadgeStyle, openInNewTab} from '@/Utils/CommonUtils';
import SlideModal from '@/Atoms/SlideModal';
import CCDatePicker from '@/Atoms/CCDatePicker';
import usePauseCsocSubscription from '@/Hooks/SubscriptionApi/usePauseCsocSubscription';
import useResumeCsocSubscription from '@/Hooks/SubscriptionApi/useResumeCsocSubscription';
import useGetCsocPauseLimits from '@/Hooks/SubscriptionApi/useGetCsocPauseLimits';
import useAlertModalStore from '@/Store/AlertModalStore';
import ChipList from '@/Atoms/ChipList/ChipList';
import CCSelect from '@/Atoms/CCSelect';
import useGetOrderDetailsDetailsApi from '@/Hooks/SubscriptionDetails/useGetOrderDetails';
import useGetCsocSubscriptionDetailsApi from '@/Hooks/SubscriptionDetails/useCsocSubscription';
import SubscriptionSideModal from './SubscriptionSideModal';
import SubscriptionCard from './SubscriptionCard';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {getStatusStyles} from '../MentorCalls';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';
import useWebinarApi from '@/Hooks/WebinarApi/useWebinarApi';
import {getUTCOffset} from '@/Utils/CommonUtils';
import MeetingsBanner from '../MeetingsBanner';
import {ICON_MAP} from '../Meetings';
// import {loadChallengeState} from '@/Screens/RenewalPuzzleChallenge/utils';
// import {PersistedChallengeState} from '@/Screens/RenewalPuzzleChallenge/types';

const tabHeaders = [
  'Order ID',
  'Payment Date',
  'Plan Name',
  'Amount Paid',
  'Status',
  '',
];

const SubscriptionTab = ({userContact, userId, userKey, banner}) => {
  const {isMobileOrTab} = useMediaQuery();
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  // const [showRenewalBanner, setShowRenewalBanner] = useState(false);
  // const [challengeState, setChallengeState] = useState<PersistedChallengeState | null>(null);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [pauseOrderId, setPauseOrderId] = useState('');
  const [pauseEndDate, setPauseEndDate] = useState<Date | null>(null);
  const [pauseError, setPauseError] = useState('');
  const [resumeError, setResumeError] = useState('');
  const [pauseLimits, setPauseLimits] = useState<any>(null);
  const [pauseLimitsError, setPauseLimitsError] = useState('');
  const [selectedWeeks, setSelectedWeeks] = useState(1);
  const openAlertModal = useAlertModalStore(state => state.openModal);
  const [firstOrder, setFirstOrder] = useState('');
  const [refreshToken, setRefreshToken] = useState(0);
  const [statusMessage, setStatusMessage] = useState<any>(null);
  const {mutate: getWebinarDetailsForBanner} = useWebinarApi((resp: any) => {
    setStatusMessage(resp?.data?.status_message || null);
  });
  const [openSideModal, setOpenSideModal] = useState(false);
  const [openSideModalOnClick, setOpenSideModalOnClick] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [hoveredSubId, setHoveredSubId] = useState<number | null>(null);
  const [openDropdownId, setOpenDropdownId] = useState<number | null>(null);
  const [openMore, setOpenMore] = useState(false);
  const [showProgressReportModal, setShowProgressReportModal] = useState(false);
  const [activeProgressReports, setActiveProgressReports] = useState<any[]>([]);
  const navigation = useNavigation();
  // const {data: renewalData, isLoading: isLoadingRenewal} =
  //   useGetRenewalForUser();

  // Show renewal banner if eligible (but hide for international users)
  // useEffect(() => {
  //   if (renewalData?.banner?.should_show) {
  //     // Check if user is international - hide banner if so
  //     const mobileNumber = renewalData?.user?.mobile;
  //     if (mobileNumber) {
  //       setShowRenewalBanner(true);
  //     }
  //     const stored = loadChallengeState(userId || 'guest');
  //     setChallengeState(stored);
  //   }
  // }, [renewalData, userId]);

  useEffect(() => {
    if (resumeError) {
      openAlertModal({
        header: 'Error',
        bodyTxt: resumeError,
        buttonText: 'OK',
        handleConfirmation: () => {
          setResumeError('');
        },
      });
    }
  }, [resumeError]);
  const handleOnError = (error: any) => {
    console.log('Error fetching subscription details:', error);
  };
  const handleOnSuccessSubscriptionDetails = (data: any) => {
    console.log('Subscription details = ', data);
    setSubscriptionDetails(data?.data);
    setFirstOrder(data?.data?.[0]?.order_id);
  };
  const {mutate: getCsocSubscriptionDetails} = useGetCsocSubscriptionDetailsApi(
    handleOnSuccessSubscriptionDetails,
    handleOnError,
  );
  const handleOnSuccessCsocDetails = data => {};
  const handleOnCsocError = data => {};
  const {mutate: getSubscriptionDetails} = useGetSubscriptionDetailsApi(
    handleOnSuccessCsocDetails,
    handleOnCsocError,
  );
  const handleOnSuccessOrderDetails = data => {
    console.log('order details', data);
    setOpenSideModal(true);
    setOrderDetails(data?.order);
    setSubscriptions(data?.subscriptions);
    setInvoice(data?.invoice);
  };
  const handleOnOrderError = data => {};
  const {mutate: getSubscriptionOrderDetails} = useGetOrderDetailsDetailsApi(
    handleOnSuccessOrderDetails,
    handleOnOrderError,
  );
  const {mutate: pauseSubscription, isLoading: isPausing} =
    usePauseCsocSubscription(
      (data: any) => {
        setShowPauseModal(false);
        setPauseEndDate(null);
        setPauseOrderId('');
        setPauseError('');
        setSelectedWeeks(1);
        if (userId) {
          getCsocSubscriptionDetails({userId, source: 'subscription_tab', platform: 'web'});
        }
        setRefreshToken(t => t + 1);
      },
      (error: any) => {
        setPauseError(
          error?.response?.data?.detail ||
            error?.response?.data?.message ||
            error?.message ||
            'Failed to pause subscription',
        );
      },
    );
  const handleView = orderId => {
    setOpenSideModalOnClick(true);
    setOpenMore(false);
    getSubscriptionOrderDetails({orderId: orderId, userId: userId});
  };
  const {mutate: resumeSubscription, isLoading: isResuming} =
    useResumeCsocSubscription(
      () => {
        // Hide the paused banner immediately on resume (don't wait for the
        // webinar re-fetch, which can still report paused for a moment).
        setStatusMessage(null);
        if (userId) {
          getCsocSubscriptionDetails({userId, source: 'subscription_tab', platform: 'web'});
        }
        setRefreshToken(t => t + 1);
      },
      (error: any) => {
        setResumeError(
          error?.response?.data?.detail ||
            error?.response?.data?.message ||
            error?.message ||
            'Failed to resume subscription',
        );
        // setPauseError(error?.message || 'Failed to resume subscription');
      },
    );
  const {mutate: getPauseLimits, isLoading: isLoadingPauseLimits} =
    useGetCsocPauseLimits(
      data => {
        console.log('Pause limits = ', {...data?.limits, ...data});
        setPauseLimits({...data?.limits, ...data});
        setPauseLimitsError('');
      },
      (error: any) => {
        setPauseLimitsError(error?.message || 'Failed to load pause limits');
      },
    );
  useEffect(() => {
    getSubscriptionDetails();
  }, []);
  useEffect(() => {
    if (userId) {
      getCsocSubscriptionDetails({userId, source: 'subscription_tab', platform: 'web'});
    }
  }, [userId]);
  useEffect(() => {
    if (userKey) {
      getWebinarDetailsForBanner({user_key: userKey, timezone: getUTCOffset()});
    }
  }, [userKey, refreshToken]);
  const paginate = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      getSubscriptionDetails();
    }
  };
  const [tableData, setTableData] = useState<
    Array<
      Array<{
        name: string;
        type: 'text' | 'link' | 'dropdown';
        url?: string;
        options?: string[];
      }>
    >
  >([]);
  const formatSimpleDate = (dateStr: string) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
  };

  // const getSubscriptionBadgeStyle = (status: string) => {
  //   switch (status?.toLowerCase()) {
  //     case 'active':
  //       return {backgroundColor: '#F0EBE1', textColor: '#5C4A2A'};
  //     case 'upcoming':
  //       return {backgroundColor: '#EEF3E2', textColor: '#3D5A1F'};
  //     case 'expired':
  //       return {backgroundColor: '#F0F0F0', textColor: '#666666'};
  //     case 'paused':
  //       return {backgroundColor: '#FFF3CD', textColor: '#856404'};
  //     default:
  //       return {backgroundColor: '#F0F0F0', textColor: '#333333'};
  //   }
  // };

  const splitBold = (message: string): [string, string] => {
    const numMatch = message.match(/^(\d+)(\s.+)$/);
    if (numMatch) return [numMatch[1], numMatch[2]];
    const wordMatch = message.match(/^(.*?)(\s(?:every|after|in|per|a\s).+)$/);
    if (wordMatch?.[1]) return [wordMatch[1], wordMatch[2]];
    return ['', message];
  };

  function formatDate(dateOnly) {
    // Split into year, month, and day
    const [year, month, day] = dateOnly.split('-');

    // Month names array
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    function getOrdinalSuffix(day) {
      const dayNumber = parseInt(day, 10);
      if (dayNumber >= 11 && dayNumber <= 13) return 'th';
      switch (dayNumber % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    }
    // Convert month number to month name
    const monthName = monthNames[parseInt(month, 10) - 1];
    const ordinalSuffix = getOrdinalSuffix(day);
    // Format to dd MMM yy
    return `${day}${ordinalSuffix} ${monthName} '${year.slice(2)}`;
  }
  const customFlexArr = [1.6, 1.6, 1.6, 1.6, 1.6, 0.6];
  const formatPauseEndDate = (value: Date | null) => {
    if (!value || isNaN(value.getTime())) {
      return '';
    }
    const day = String(value.getDate()).padStart(2, '0');
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const year = value.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatIsoDate = (value?: string | null) => {
    if (!value) {
      return 'N/A';
    }
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
      return 'N/A';
    }
    return formatPauseEndDate(parsed);
  };

  const remainingPauseDays = Number(pauseLimits?.max_pause_days_remaining || 0);
  const minPauseDate = pauseLimits?.min_pause_end_date
    ? new Date(pauseLimits.min_pause_end_date)
    : new Date();
  const maxPauseDate = pauseLimits
    ? remainingPauseDays > 0 && pauseLimits?.max_pause_end_date
      ? new Date(pauseLimits.max_pause_end_date)
      : minPauseDate
    : null;

  const calculatedPauseEndDate = new Date();
  calculatedPauseEndDate.setDate(
    calculatedPauseEndDate.getDate() +
      Math.min(selectedWeeks * 7, remainingPauseDays),
  );

  const maxWeeks = Math.floor(remainingPauseDays / 7);
  const weekOptions = Array.from({length: maxWeeks}, (_, i) => i + 1).map(
    weeks => ({
      label: `${weeks} week${weeks > 1 ? 's' : ''}`,
      value: weeks,
    }),
  );

  const handleResumeSubscription = (order_id, fromBanner?: boolean) => {
    openAlertModal({
      header: 'Confirm',
      bodyTxt: `Are you sure you want to resume this subscription?`,
      buttonText: 'Yes, resume',
      cancelText: 'Cancel',
      handleConfirmation: () => {
        resumeSubscription(
          fromBanner
            ? {order_id, source: 'subscription_tab', platform: 'web'}
            : {order_id},
        );
      },
      handleCancel: () => {},
    });
  };
  useEffect(() => {
    if (subscriptionDetails && Array.isArray(subscriptionDetails)) {
      const itemsPerPage = 10;
      const totalItems = subscriptionDetails.length;

      setTotalPages(Math.ceil(totalItems / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      const paginatedData = subscriptionDetails.slice(startIndex, endIndex);
      const formattedData = paginatedData.map(item => {
        console.log('subscription is .... : ', item);
        const order_id = item?.order_id;
        const paymentDate = item?.payment_date;
        const planeName = item?.plan_name;
        const amount = item?.amount_paid;
        const currency = item?.currency;
        const planStatus = item?.status;

        let itemValues: any = [];
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="row" style={styles.tableStyle}>
              <CCText fontSize={FontSizes[15]} fontWeight={600}>
                Order ID:
              </CCText>
              <CCText fontSize={FontSizes[15]}> {order_id}</CCText>
            </Box>
          ) : (
            <Box style={styles.tableCStyle}>
              <Box type="row-center" style={styles.rowCFlex}>
                <CCText fontWeight={400} fontSize={FontSizes[12]}>
                  {order_id}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="row" style={styles.tableStyle}>
              <CCText fontSize={FontSizes[15]} fontWeight={600}>
                Payment Date:
              </CCText>
              <CCText fontSize={FontSizes[15]}> {paymentDate}</CCText>
            </Box>
          ) : (
            <Box style={styles.tableCStyle}>
              <Box type="row-center" style={styles.rowCFlex}>
                <CCText fontWeight={400} fontSize={FontSizes[12]}>
                  {paymentDate}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="column" style={styles.tableStyle}>
              <Box flexDirection="row">
                <CCText fontSize={FontSizes[15]} fontWeight={600}>
                  Plan Name:{' '}
                </CCText>
                <CCText fontSize={FontSizes[15]}>{planeName}</CCText>
              </Box>
            </Box>
          ) : (
            <Box style={styles.tableCStyle}>
              <Box type="row-center" style={styles.rowCFlex}>
                <CCText fontWeight={400} fontSize={FontSizes[12]}>
                  {planeName}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="row" style={styles.tableStyle}>
              <CCText fontSize={FontSizes[15]} fontWeight={600}>
                Amount:{' '}
              </CCText>
              <CCText fontSize={FontSizes[15]}> {amount}</CCText>
            </Box>
          ) : (
            <Box style={styles.tableCStyle}>
              <Box type="row-center" style={styles.rowCFlex}>
                <CCText fontWeight={400} fontSize={FontSizes[12]}>
                  {currency} {amount}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="row" style={styles.tableStyle}>
              <CCText fontSize={FontSizes[15]} fontWeight={600}>
                Status:{' '}
              </CCText>
              <CCText fontSize={FontSizes[15]}>{planStatus}</CCText>
            </Box>
          ) : (
            <Box style={styles.tableCStyle}>
              <Box
                type="row-center"
                style={[
                  styles.rowCFlex,
                  {
                    backgroundColor:
                      getSubscriptionBadgeStyle(planStatus)?.backgroundColor,
                    borderRadius: 4,
                    paddingHorizontal: 8,
                    paddingVertical: 6,
                    margin: 'auto',
                    width: 'auto',
                  },
                ]}>
                <CCText
                  fontWeight={600}
                  fontSize={FontSizes[12]}
                  color={getSubscriptionBadgeStyle(planStatus)?.textColor}>
                  {planStatus}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        itemValues.push({
          name: isMobileOrTab ? (
            <Box
              onPress={() => handleView(item?.order_id)}
              flexDirection="row"
              style={styles.tableStyle}>
              <CCText
                color={CCColors.BlueAqua}
                fontSize={FontSizes[15]}
                fontWeight={600}>
                View
              </CCText>
            </Box>
          ) : (
            <Box style={styles.tableCStyle}>
              <Box
                onPress={() => handleView(item?.order_id)}
                type="row-flex-start"
                style={styles.rowCFlex}>
                <MaterialCommunityIcons name="eye-outline" size={22} />
              </Box>
            </Box>
          ),
          type: 'text',
        });

        return itemValues;
      });
      setTableData(formattedData || []);
    }
  }, [subscriptionDetails, currentPage, isMobileOrTab]);

  const cardData = [
    {
      title: 'Live Classes',
      desc: 'Live IM/GM Classes',
      icon: require('@/Assets/Images/Meetings/Instructor.svg'),
    },
    {
      title: 'Coach',
      desc: 'Personalized training',
      icon: require('@/Assets/Images/Meetings/Coach.svg'),
    },
    {
      title: 'Mentor',
      desc: '1-on-1 Mentor Sessions',
      icon: require('@/Assets/Images/Meetings/Mentor.svg'),
    },
    {
      title: 'Practice',
      desc: 'Learn, compete, & grow',
      icon: require('@/Assets/Images/Meetings/Practice.svg'),
    },
  ];

  const pausedResumeOrderId = (
    Array.isArray(subscriptionDetails) ? subscriptionDetails : []
  ).find(o => (o?.status || '').toLowerCase() === 'paused')?.order_id;

  return (
    <ScrollView style={{padding: isMobileOrTab ? 10 : 20}}>
      {statusMessage ? (
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          style={[
            {paddingVertical: '0.5%', borderRadius: 8},
            {backgroundColor: CCColors.Primary.Dark, marginBottom: 12},
          ]}>
          <MeetingsBanner
            backgroundColor={CCColors.Primary.Dark}
            iconName={ICON_MAP?.[statusMessage.icon]?.name}
            iconColor={CCColors.White}
            onClose={() => {}}
            titleText={
              statusMessage.main_text
                ? statusMessage.main_text.charAt(0).toUpperCase() +
                  statusMessage.main_text.slice(1)
                : ''
            }
            subtitleText={
              statusMessage.sub_text
                ? statusMessage.sub_text.charAt(0).toUpperCase() +
                  statusMessage.sub_text.slice(1)
                : ''
            }
            ctaText={statusMessage.cta_details?.[0]?.text}
            highlight={statusMessage.cta_details?.[0]?.highlight || 0}
            closeIcon={statusMessage.close_icon}
            handlePress={() =>
              pausedResumeOrderId &&
              handleResumeSubscription(pausedResumeOrderId, true)
            }
            textColor={CCColors.White}
            isMobileOrTab={isMobileOrTab}
          />
        </Box>
      ) : (
        banner
      )}
      <CCLoader
        loading={isResuming || isPausing}
        bgStyle={{backgroundColor: CCColors.Primary.Light}}
      />
      {/* {showRenewalBanner && renewalData && (
        <Box paddingHorizontal={isMobileOrTab ? 10 : 20} marginBottom={15}>
          <RenewalBanner
            daysLeft={Number(
              renewalData?.current_subscription?.days_to_expiry || 100,
            )}
            couponDiscountPercentage={
              challengeState?.completed
                ? challengeState.couponDiscount
                : Number(renewalData?.coupon?.discount_value) ?? 0
            }
            expiryDate={renewalData?.current_subscription?.end_date}
            // daysLeft={1}
            sessionsLeft={renewalData?.current_subscription?.sessions_left ?? 0}
            couponCode={
              challengeState?.completed
                ? challengeState.couponCode
                : renewalData?.coupon?.code
            }
            // onRenewNow={() => {
            //   navigation.navigate(ScreenName.Renewal, {userId});
            // }}
            onClose={() => setShowRenewalBanner(false)}
            challengeCompleted={challengeState?.completed ?? false}
            onEarnDiscount={() =>
              (navigation as any).navigate(ScreenName.RenewalPuzzleChallenge)
            }
          />
        </Box>
      )} */}
      <Spacer spacing={vs(16)} />
      <SlideModal
        visible={showPauseModal}
        type="center"
        modalHeaderTitle="Pause Subscription"
        customStyle={{justifyContent: 'center', alignItems: 'center'}}>
        <CCLoader
          loading={isLoadingPauseLimits}
          bgStyle={{backgroundColor: `${CCColors.Primary.Light}80`}}
        />
        <Box
          style={{
            backgroundColor: CCColors.White,
            borderRadius: 16,
            padding: 20,
            width: isMobileOrTab ? '90%' : 420,
            maxWidth: '100%',
          }}>
          {/* Header Icon & Title */}
          <Box style={styles.helper}>
            <Box style={styles.forty}>
              <Icon name="pause" size={24} color={CCColors.White} />
            </Box>
            <CCText
              fontSize={FontSizes[18]}
              fontWeight={600}
              style={{textAlign: 'center'}}>
              Pause Your Subscription
            </CCText>
            <Spacer spacing={vs(4)} />
            <CCText
              fontSize={FontSizes[13]}
              color={CCColors.Grey.Grey}
              style={{textAlign: 'center', lineHeight: 18}}>
              Choose when you'd like to resume your learning journey
            </CCText>
          </Box>

          <Spacer spacing={vs(16)} />

          {/* Pause Information Card */}
          {isLoadingPauseLimits ? (
            <Box
              style={{
                backgroundColor: `${CCColors.Grey.LightGrey}40`,
                borderRadius: 12,
                padding: 14,
                alignItems: 'center',
              }}>
              <CCLoader size="small" />
            </Box>
          ) : pauseLimits ? (
            <Box
              style={{
                backgroundColor: CCColors.White,
                borderRadius: 12,
                padding: 14,
                borderWidth: 1,
                borderColor: CCColors.Grey.LightGrey,
              }}>
              <Box type="row-center-between" style={{marginBottom: 10}}>
                <CCText fontSize={FontSizes[14]} fontWeight={500}>
                  Remaining pause days
                </CCText>
                <Box
                  style={{
                    backgroundColor:
                      remainingPauseDays > 0
                        ? CCColors.success
                        : CCColors.Error,
                    paddingHorizontal: 12,
                    paddingVertical: 4,
                    borderRadius: 12,
                  }}>
                  <CCText
                    fontSize={FontSizes[13]}
                    fontWeight={600}
                    color={CCColors.White}>
                    {remainingPauseDays} days
                  </CCText>
                </Box>
              </Box>
              <Box type="row-center-between">
                <CCText fontSize={FontSizes[13]} color={CCColors.Grey.Grey}>
                  Max pause till
                </CCText>
                <CCText fontSize={FontSizes[14]} fontWeight={500}>
                  {formatIsoDate(pauseLimits?.max_pause_end_date)}
                </CCText>
              </Box>
            </Box>
          ) : null}

          {pauseLimitsError ? (
            <>
              <Spacer spacing={vs(10)} />
              <Box
                style={{
                  backgroundColor: `${CCColors.Error}10`,
                  borderRadius: 8,
                  padding: 10,
                  borderLeftWidth: 3,
                  borderLeftColor: CCColors.Error,
                }}>
                <CCText fontSize={FontSizes[12]} color={CCColors.Error}>
                  {pauseLimitsError}
                </CCText>
              </Box>
            </>
          ) : null}

          <Spacer spacing={vs(16)} />

          {/* Week Selection Section */}
          <Box>
            <CCText
              fontSize={FontSizes[14]}
              fontWeight={500}
              style={{marginBottom: 6}}>
              Select Pause Duration
            </CCText>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors.Grey.Grey}
              style={{marginBottom: 10}}>
              Your subscription will automatically resume on{' '}
              {formatIsoDate(calculatedPauseEndDate)}
            </CCText>
            <Box type="row-flex-start" style={{gap: 10}}>
              <CCSelect
                ccSelectHeight={45}
                ccSelectWidth="100%"
                placeholder="Select pause duration"
                selectedValue={selectedWeeks}
                onValueChange={value => setSelectedWeeks(value)}
                items={weekOptions}
              />
            </Box>
          </Box>

          {pauseError ? (
            <>
              <Spacer spacing={vs(10)} />
              <Box
                style={{
                  backgroundColor: `${CCColors.Error}10`,
                  borderRadius: 8,
                  padding: 10,
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                }}>
                <Icon
                  name="error"
                  size={16}
                  color={CCColors.Error}
                  style={{marginTop: 1}}
                />
                <Spacer spacing={vs(6)} horizontal />
                <CCText
                  fontSize={FontSizes[12]}
                  color={CCColors.Error}
                  style={{flex: 1}}>
                  {pauseError}
                </CCText>
              </Box>
            </>
          ) : null}

          <Spacer spacing={vs(18)} />

          {/* Action Buttons */}
          <Box type="row-center-between" style={{gap: 10}}>
            <CCButton
              style={{
                flex: 1,
                paddingVertical: 12,
                backgroundColor: CCColors.White,
                borderWidth: 1.5,
                borderColor: CCColors.Black,
                borderRadius: 10,
              }}
              onPress={() => {
                setShowPauseModal(false);
                setPauseError('');
                setSelectedWeeks(1);
              }}>
              <CCText
                fontSize={FontSizes[14]}
                fontWeight={500}
                color={CCColors.Black}>
                Cancel
              </CCText>
            </CCButton>

            <CCButton
              style={{
                flex: 1,
                paddingVertical: 12,
                backgroundColor: isPausing
                  ? CCColors.Grey.LightGrey
                  : CCColors.YellowDark,
                borderRadius: 10,
                opacity: isPausing ? 0.6 : 1,
              }}
              onPress={() => {
                if (pauseLimits && remainingPauseDays <= 0) {
                  setPauseError('Pause limit exhausted for this subscription');
                  return;
                }
                const formattedDate = formatPauseEndDate(
                  calculatedPauseEndDate,
                );
                pauseSubscription({
                  order_id: pauseOrderId,
                  pause_end_date: formattedDate,
                  paused_by_student: true,
                });
              }}
              disabled={isPausing}>
              <Box type="row-center" style={{gap: 6}}>
                {isPausing && <CCLoader size="small" color={CCColors.White} />}
                <CCText
                  fontSize={FontSizes[14]}
                  fontWeight={600}
                  color={CCColors.White}>
                  {isPausing ? 'Pausing...' : 'Confirm Pause'}
                </CCText>
              </Box>
            </CCButton>
          </Box>
        </Box>
      </SlideModal>
      <SlideModal
        visible={showProgressReportModal}
        type="center"
        minWidth={WINDOW_WIDTH / 3}
        contentPadding={0}
        customHeaderStyle={{display: 'none'}}
        onClose={() => setShowProgressReportModal(false)}>
        <Box flex={1} style={styles.flx}>
          <Box
            flexDirection="row"
            justifyContent="space-between"
            style={styles.rw}>
            <CCText fontSize={FontSizes[18]} fontWeight="semibold">
              Download Progress Reports
            </CCText>
            <TouchableOpacity onPress={() => setShowProgressReportModal(false)}>
              <Box type="center" style={styles.close}>
                <Ionicons name="close-outline" size={22} color="black" />
              </Box>
            </TouchableOpacity>
          </Box>
          {activeProgressReports.map((report: any, index: number) => {
            const ordinal = (n: number) => {
              const s = ['th', 'st', 'nd', 'rd'];
              const v = n % 100;
              return n + (s[(v - 20) % 10] || s[v] || s[0]);
            };
            const isLast = index === activeProgressReports.length - 1;
            return (
              <Box
                key={report?.cycle}
                onPress={() => openInNewTab(report?.report_url)}
                type="row-center-between"
                style={[styles.icnbg, {borderBottomWidth: isLast ? 0 : 1}]}>
                <Box type="row-flex-start" style={{gap: 12}}>
                  <MaterialCommunityIcons name="file-chart-outline" size={20} />
                  <Box>
                    <CCText fontWeight="semibold" fontSize={FontSizes[14]}>
                      {ordinal(report?.cycle)} Month
                    </CCText>
                  </Box>
                </Box>
                <CCButton
                  onPress={() => openInNewTab(report?.report_url)}
                  contentContainerStyle={styles.cur}>
                  <CCText fontSize={FontSizes[10]} fontWeight={600}>
                    Download
                  </CCText>
                </CCButton>
              </Box>
            );
          })}
        </Box>
      </SlideModal>
      <SubscriptionSideModal
        openSideModal={openSideModal && openSideModalOnClick}
        setOpenSideModal={setOpenSideModal}
        orderDetails={orderDetails}
        subscriptions={subscriptions}
        invoice={invoice}
        hoveredSubId={hoveredSubId}
        setHoveredSubId={setHoveredSubId}
        openDropdownId={openDropdownId}
        setOpenDropdownId={setOpenDropdownId}
        setActiveProgressReports={setActiveProgressReports}
        setShowProgressReportModal={setShowProgressReportModal}
        handleResumeSubscription={handleResumeSubscription}
        setPauseOrderId={setPauseOrderId}
        setPauseEndDate={setPauseEndDate}
        setPauseError={setPauseError}
        setPauseLimits={setPauseLimits}
        setPauseLimitsError={setPauseLimitsError}
        setShowPauseModal={setShowPauseModal}
        getPauseLimits={getPauseLimits}
      />

      <Box
        type={isMobileOrTab ? 'center' : 'column-flex-between'}
        style={{
          marginLeft: isMobileOrTab ? 0 : 15,
        }}>
        {(Array.isArray(subscriptionDetails) ? subscriptionDetails : [])
          .filter(order =>
            ['active', 'paused', 'upcoming'].includes(
              (order?.status || '').toLowerCase(),
            ),
          )
          .map(order => (
            <SubscriptionCard
              key={order?.order_id}
              orderId={order?.order_id}
              userId={userId}
              refreshToken={refreshToken}
              setActiveProgressReports={setActiveProgressReports}
              setShowProgressReportModal={setShowProgressReportModal}
              handleResumeSubscription={handleResumeSubscription}
              setPauseOrderId={setPauseOrderId}
              setPauseEndDate={setPauseEndDate}
              setPauseError={setPauseError}
              setPauseLimits={setPauseLimits}
              setPauseLimitsError={setPauseLimitsError}
              setShowPauseModal={setShowPauseModal}
              getPauseLimits={getPauseLimits}
              isMobileOrTab={isMobileOrTab}
            />
          ))}
        {tableData?.length > 0 && (
          <CCText
            fontWeight={500}
            fontSize={FontSizes[24]}
            color={CCColors.Primary.Dark}>
            Orders History
          </CCText>
        )}
        {isMobileOrTab && <Spacer spacing={10} />}
      </Box>
      <Spacer spacing={24} />
      <Box
        style={{
          backgroundColor: isMobileOrTab ? CCColors.White : '',
          borderRadius: isMobileOrTab ? 8 : 0,
        }}>
        {tableData?.length > 0 ? (
          <>
            <View style={styles.blc}>
              <CCPackageTable
                flexArr={customFlexArr}
                headers={tabHeaders}
                tableData={tableData}
                borderBottomColor={CCColors.BorderBottom}
                headerTextColor={CCColors.TextColor.Grey}
                margin={0}
                jsxTable={false}
                isMargin={false}
                tournament={false}
                backgroundColorRow={true}
                tableBorder={false}
                highlightedBorder={false}
                tablePadding={true}
                headerHeight={55}
                tableShadow={true}
                customBlockRow={{
                  backgroundColor: CCColors.White,
                  borderColor: CCColors.BorderBottom,
                  padding: 0,
                }}
                customCellBlock={{
                  borderBottomWidth: 0,
                  padding: 0,
                }}
                isBorderBottomRow={true}
                customBorderwidth={'90%'}
                customLeft={'5%'}
                shiftHeaders={true}
              />
            </View>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              paginate={paginate}
            />
          </>
        ) : (
          <EmptyView mobileNumber={userContact} activeTab={'subscriptions'} />
        )}
      </Box>
    </ScrollView>
  );
};

export default SubscriptionTab;
